<template>
  <SDialog title="Table" :persistent="true" :width="450" @close="closeModal">
    <div style="padding: 24px" v-grid="1">
      <SInput
          label="name"
          v-model="name"
      />
      <SButton title="Add" @click="addAttribute" />
    </div>
  </SDialog>
</template>
<script>
import SDialog from "../SDialog";
import SInput from "../SInput.vue";
import SButton from "../SButton.vue";
export default {
  name: "Table",
  components: { SDialog, SInput, SButton },
  data() {
    return {
      name: "",
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    addAttribute() {
      this.$emit("add", this.selectedElementId,this.name);
    },
  },

  props: {
      selectedElementId:{}
  },
};
</script>

<style lang="scss" scoped>
.columns {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
  row-gap: 16px;
  align-items: center;
}
</style>